import { RootState } from '../../types/store-types';
import { UserActivityState } from './user-activity-state';

export const getUserActivity = (state: RootState): UserActivityState => state.userActivity;

export const getIsPostNew =
  (state: RootState) =>
  (postId: string): boolean =>
    getUserActivity(state).newPosts?.includes(postId);
